// Element finding functions
export function getElement(id) {
    const element = document.getElementById(id);
    if (!element)
        throw new Error(`Element with ID ${id} not found`);
    return element;
}
export function getElements(selector) {
    const elements = document.querySelectorAll(selector);
    return elements;
}
export function getFirstElement(selector) {
    const element = document.querySelector(selector);
    return element;
}
